(function(GaTest, $, undefined) {

  var checkLegacyVariation = function() {
    var isLegacyVariation = getCookie('ss.legacyVariation');
    console.log(isLegacyVariation)

    if (isLegacyVariation) {
      const $newIndexLinks = $('a[href="/"]'); 
      const $newShopLinks = $('a[href="/collections/soloshot3"]');
      $('[data-hide-test]').hide();
      $($newIndexLinks).each(function() {
        $(this).attr('href', '/pages/soloshot-home');
      });
      $($newShopLinks).each(function() {
        $(this).attr('href', '/collections/all');
      });
    }
  }

  GaTest.init = function() {
    $(document).on('ready', function() {
      if(window.location.href.indexOf('soloshot-home') > -1) {
        setCookie('ss.legacyVariation', true);
      }
      checkLegacyVariation();
    })
  }

}(window.GaTest = window.GaTest || {}, jQuery));